module.exports = __webpack_public_path__ + "static/media/match-pairs-face-sprite.44fbc503.svg";